// frontend/src/features/agency/AgencyDriverHeader.js
// Agency banner header (modeled after UPS UpsDriverStats)
//
// Purpose:
// - Provide a consistent top "banner" for Agency driver pages
// - Hosts: Site selector + Search + (optional) global scope toggle + Counters
//
// Notes:
// - Does not fetch lane data. Only renders controls.
// - Counters are fetched by <AgencyDriverStats /> (existing behavior).
// - Search + scope are stored in ui/filtersSlice (same as UPS).

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import SiteSelector from '../../components/SiteSelector';
import AgencyDriverStats from '../../components/AgencyDriverStats';
import AgencyGlobalResultsDrawer from './AgencyGlobalResultsDrawer';

import { selectFilters, setQuery, setScope } from '../ui/filtersSlice';

export default function AgencyDriverHeader() {
  const dispatch = useDispatch();
  const { q, scope } = useSelector(selectFilters);

  const location = useLocation();
  const pathname = location.pathname || '';

  // Available drivers are not site-scoped (no open assignment)
  const showSiteSelector = !pathname.endsWith('/available');

  const onSearchChange = (e) => dispatch(setQuery(e.target.value));
  const onScopeToggle = (e) => dispatch(setScope(e.target.checked ? 'global' : 'tab'));

  return (
    <div className="mb-4 space-y-3">
      {/* Controls */}
      <div className="flex flex-wrap items-end gap-3">
        {/* Site (not applicable for Available lane) */}
        {showSiteSelector && <SiteSelector />}

        {/* Search */}
        <div className="flex-1 min-w-[240px]">
          <label className="block text-sm font-medium text-gray-700 mb-1">Search</label>
          <input
            value={q || ''}
            onChange={onSearchChange}
            placeholder="Search drivers…"
            className="border rounded h-9 px-2 w-full"
          />
        </div>

        {/* Scope toggle (optional parity with UPS) */}
        <label className="inline-flex items-center gap-2 text-sm pb-1">
          <input
            type="checkbox"
            checked={scope === 'global'}
            onChange={onScopeToggle}
          />
          <span>Search all statuses</span>
        </label>
      </div>

      {/* Figures */}
      <AgencyDriverStats />

      {/* Global search results (only shows when scope === 'global' and q is non-empty) */}
      <AgencyGlobalResultsDrawer />
    </div>
  );
}
